import React, { Component } from 'react'
import { Route, Redirect, Switch } from 'react-router'
import App from './AppContainer';
import LoginContainer from './LoginContainer'
import RegisterContainer from './RegisterContainer'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { push } from 'react-router-redux'
import { checkAction } from '../../actions/contentActions'
import { logInByTokenAction, logOutAction } from '../../actions/authActions'

class Root extends Component {
  account = this.props.appState.account;
  dispatch = this.props.dispatch;
  pathname = this.props.location.pathname;

  componentWillMount() {
    /* if (!this.account.loggedIn && this.pathname !== '/register') {
      this.dispatch(push('/login'))
    } */
    this.props.check()
  }
  handleMathscircleLogin = data => {
    const params = new URLSearchParams(this.props.location.search);
    const token = params.get('token');
    if (!token)
      window.location.replace('/login')
    this.props.logInByTokenAction(token)
    return null
  }
  render() {
    return (
      <Switch>
        <Route exact path="/logout" render={() => {
          this.props.logOut()
          return null
        }} />
        <Route exact path="/login" component={LoginContainer} />
        <Route path="/login/mathscircle" component={this.handleMathscircleLogin} />
        <Route path="/register" component={RegisterContainer} />
        <Route path="/" component={App} />
      </Switch>
    );
  }
}

const mapStateToProps = state => {
  return {
    appState: state
  }
}

const mapDispatchToProps = dispatch => {
  return {
    check: () => {
      dispatch(checkAction())
    },
    logInByTokenAction: (token) => {
      dispatch(logInByTokenAction(token))
    },
    logOut: () => {
      dispatch(logOutAction())
    }
  }
}

//  store.dispatch(push('/login'))

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(Root));



// WEBPACK FOOTER //
// ./src/components/containers/RootContainer.js